module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Season of Sacrifice")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("‘Truth exists, only falsehood has to be invented.’")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source-space-after"
  }, [_vm._v("Georges Braque")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("‘We do not live an equal life, but one of contrasts and patchwork; now a little joy, then a sorrow, now a sin, then a generous or brave action.’")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("Ralph Waldo Emerson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 81
// module chunks = 0